module.exports = __webpack_public_path__ + "img/excavator-green.10b80206.svg";